import { render, staticRenderFns } from "./Circulo.vue?vue&type=template&id=963dbcec&scoped=true&"
import script from "./Circulo.vue?vue&type=script&lang=js&"
export * from "./Circulo.vue?vue&type=script&lang=js&"
import style0 from "./Circulo.vue?vue&type=style&index=0&id=963dbcec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963dbcec",
  null
  
)

export default component.exports